export const ABOUTS_DOMAIN = 'abouts'

export const ABOUTS_KEY = {
  ALL: 'all',
  CURRENT: 'current',
  DATA: 'data'
}

export const ABOUTS_PATH = {
  ALL: `${ABOUTS_DOMAIN}.${ABOUTS_KEY.ALL}`,
  CURRENT: `${ABOUTS_DOMAIN}.${ABOUTS_KEY.CURRENT}`,
  DATA: `${ABOUTS_DOMAIN}.${ABOUTS_KEY.DATA}`
}

export const ABOUTS_STATE = {
  [ABOUTS_KEY.ALL]: {
    data: [],
    status: null
  },
  [ABOUTS_KEY.CURRENT]: null,
  [ABOUTS_KEY.DATA]: {}
}

export const ABOUTS_ENDPOINT = {
  ABOUTS: '/abouts'
}
